const useIsAdmin = ({ permissions }) =>
  permissions &&
  (permissions.role === "admin" ||
    permissions.roles.some((r) => r.name === "super-user"));

export default useIsAdmin;
